import { createStore } from 'vuex'

export default createStore({
  state: {
    company: null,
    Amount: null,
    Repayment: null,
    First: null,
    Delay: null,
    prefselect: "",
    ageselect: "",
    email_c: "",
    tel1: "",
    tel: "",
    name: "",
    param: "",
    utm_source: "",
    utm_medium: "",
    utm_campaign: "",
  },
  getters: {
    company(state) {
      return state.company;
    },
    Amount(state) {
      return state.Amount;
    },
    Repayment(state) {
      return state.Repayment;
    },
    First(state) {
      return state.First;
    },
    Delay(state) {
      return state.Delay;
    },
    prefselect(state) {
      return state.prefselect;
    },
    ageselect(state) {
      return state.ageselect;
    },
    email_c(state) {
      return state.email_c;
    },
    tel1(state) {
      return state.tel1;
    },
    tel(state) {
      return (String(state.tel1));
    },
    name(state) {
      return state.name;
    },
    param(state) {
      return state.param;
    },
    utm_source(state) {
      return state.utm_source;
    },
    utm_medium(state) {
      return state.utm_medium;
    },
    utm_campaign(state) {
      return state.utm_campaign;
    },
  },
  mutations: {
    setCompany(state, payload) {
      state.company = payload.company;
    },
    setAmount(state, payload) {
      state.Amount = payload.Amount;
    },
    setRepayment(state, payload) {
      state.Repayment = payload.Repayment;
    },
    setFirst(state, payload) {
      state.First = payload.First;
    },
    setDelay(state, payload) {
      state.Delay = payload.Delay;
    },
    setPrefselect(state, payload) {
      state.prefselect = payload.prefselect;
    },
    setAgeselect(state, payload) {
      state.ageselect = payload.ageselect;
    },
    setEmail_c(state, payload) {
      state.email_c = payload.email_c;
    },
    setTel1(state, payload) {
      state.tel1 = payload.tel1;
    },
    setName(state, payload) {
      state.name = payload.name;
    },
    setParam(state, payload) {
      state.param = payload.param;
    },
    setUtmSource(state, payload) {
      state.utm_source = payload.utm_source;
    },
    setUtmMedium(state, payload) {
      state.utm_medium = payload.utm_medium;
    },
    setUtmCampaign(state, payload) {
      state.utm_campaign = payload.utm_campaign;
    },
  },
  actions: {
    updateCompany({ commit }, company) {
      commit("setCompany", { company });
    },
    updateAmount({ commit }, Amount) {
      commit("setAmount", { Amount });
    },
    updateRepayment({ commit }, Repayment) {
      commit("setRepayment", { Repayment });
    },
    updateFirst({ commit }, First) {
      commit("setFirst", { First });
    },
    updateDelay({ commit }, Delay) {
      commit("setDelay", { Delay });
    },
    updatePrefselect({ commit }, prefselect) {
      commit("setPrefselect", { prefselect });
    },
    updateAgeselect({ commit }, ageselect) {
      commit("setAgeselect", { ageselect });
    },
    updateEmail_c({ commit }, email_c) {
      commit("setEmail_c", { email_c });
    },
    updateTel1({ commit }, tel1) {
      commit("setTel1", { tel1 });
    },
    updateName({ commit }, name) {
      commit("setName", { name });
    },
    updateParam({ commit }, param) {
      commit("setParam", { param });
    },
    updateUtmSource({ commit }, utm_source) {
      commit("setUtmSource", { utm_source });
    },
    updateUtmMedium({ commit }, utm_medium) {
      commit("setUtmMedium", { utm_medium });
    },
    updateUtmCampaign({ commit }, utm_campaign) {
      commit("setUtmCampaign", { utm_campaign });
    },
  },
  modules: {},
});